import { lazyInject } from '../../services/inversify';
import { ContextService } from '../../services/context_service';
import { ApiService } from '../../services/api_service';
import { Md5 } from 'ts-md5/dist/md5';

export interface TempLogItem {
    name?: string;
    description?: string;
    data?: any;
    adminOnly?: boolean;
    // stamp?: number;
    // md5?: string;
}

class TempLog {

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    private contextServiceKey = 'TMP_LOG';

    init() {
        if (!this.contextService.get(this.contextServiceKey)) {
            this.contextService.set(this.contextServiceKey, []);
        }
    }

    set(item: TempLogItem) {
        this.init();
        const logs = this.contextService.get(this.contextServiceKey);
        const md5 = Md5.hashAsciiStr(JSON.stringify(item)).toString();
        if (!logs.find((r: any) => r.md5 === md5)) {
            const log: any = {
                ...item,
                stamp: new Date().getTime(),
                md5,
            };
            logs.push(log);
            this.contextService.set(this.contextServiceKey, logs);
        }
    }

    clear() {
        this.contextService.set(this.contextServiceKey, []);
    }

    get() {
        this.init();
        return this.contextService.get(this.contextServiceKey);
    }
}

const tempLog = new TempLog();

export function initTempLog() {
    tempLog.init();
}

export function setTempLog(item: TempLogItem) {
    tempLog.set(item);
}

export function getTempLog() {
    return tempLog.get();
}

export function clearTempLog() {
    return tempLog.clear();
}
